// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1b3a4d6c024ef722","8180":"c0c02c3a48933754"}[chunkId] + ".css";
};